import { render, staticRenderFns } from "./NbInvitationCounter.vue?vue&type=template&id=abacfdf2&"
import script from "./NbInvitationCounter.vue?vue&type=script&lang=js&"
export * from "./NbInvitationCounter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports